// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"de7bd5ad","762":"154f9396"}[chunkId] + ".css";
};